import { render, staticRenderFns } from "./DevSignup.vue?vue&type=template&id=4a020a9e&scoped=true&"
import script from "./DevSignup.vue?vue&type=script&lang=js&"
export * from "./DevSignup.vue?vue&type=script&lang=js&"
import style0 from "./DevSignup.vue?vue&type=style&index=0&id=4a020a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a020a9e",
  null
  
)

export default component.exports